import locationDistanceEditComponent from './location_distance.edit.component';

let locationDistanceEditModule = angular.module('locationDistanceEdit', [])

    .component('locationDistanceEdit', locationDistanceEditComponent)

    .name;

export default locationDistanceEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/edit/index.js